<template>
  <div class="downloadable offWhite">
    <div class="downloadable__container">
      <h2>{{ data.title }}</h2>
      <swiper
        class="downloadable__swiper"
        :spaceBetween="spaceBetween"
        :slidesPerView="1"
        :breakpoints="{
          '769': {
            slidesPerView: 3,
          },
        }"
        :navigation="{
          nextEl: '#downloadable-button-next',
          prevEl: '#downloadable-button-prev',
        }"
        :loop="data.slides.length >= 3 && isSmallScreen"
      >
        <swiper-slide
          v-for="(item, i) in data.slides"
          :key="i"
          class="downloadable__slide"
        >
          <div class="downloadable__image">
            <img :src="item.image" :alt="`Image ${i + 1}`" />
          </div>
          <a :href="item.buttonURL" target="_blank" download>
            <div class="custom-button custom-button--white">
              {{ item.buttonText }}
            </div>
          </a>
        </swiper-slide>
      </swiper>

      <button
        id="downloadable-button-prev"
        class="swiper-button-prev"
        aria-label="Previous Slide"
      >
        <span>Previous Slide</span>
      </button>
      <button
        id="downloadable-button-next"
        class="swiper-button-next"
        aria-label="Next Slide"
      >
        <span>Next Slide</span>
      </button>
    </div>

    <!--  Stickers -->

    <div class="downloadable__container-stickers">
      <swiper
        class="downloadable__swiper"
        :spaceBetween="spaceBetween"
        :slidesPerView="1"
        :breakpoints="{
          '769': {
            slidesPerView: 5,
          },
        }"
        :navigation="{
          nextEl: '#sticker-button-next',
          prevEl: '#sticker-button-prev',
        }"
        :loop="data.stickers.length >= 5 && isSmallScreen"
      >
        <swiper-slide
          v-for="(item, i) in data.stickers"
          :key="i"
          class="downloadable__slide"
        >
          <div class="downloadable__sticker">
            <video
                :src="item.sticker"
                autoplay
                muted
                loop
                playsinline
            ></video>
          </div>
          <a :href="item.buttonURL" target="_blank" download>
            <div class="custom-button custom-button--white">
              {{ item.buttonText }}
            </div>
          </a>
        </swiper-slide>
      </swiper>

      <button
        id="sticker-button-prev"
        class="sticker-button-prev"
        aria-label="Previous Slide"
      >
        <span>Previous Slide</span>
      </button>
      <button
        id="sticker-button-next"
        class="sticker-button-next"
        aria-label="Next-Slide"
      >
        <span>Next Slide</span>
      </button>
    </div>
  </div>
</template>

<script>
import Content from "../data/content";
import { Swiper, SwiperSlide } from "swiper/vue";
import {onMounted, onUnmounted, ref} from "vue";
let lang = process.env.VUE_APP_LOCALITY;

export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  setup() {
    const spaceBetween = 23;
    const isSmallScreen = ref(window.innerWidth < 769);

    const updateScreenSize = () => {
      isSmallScreen.value = window.innerWidth < 769;
    };

    onMounted(() => {
      window.addEventListener("resize", updateScreenSize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", updateScreenSize);
    });

    return {
      spaceBetween,
      isSmallScreen,
    };
  },
  data: function () {
    return {
      data: Content[lang].downloadable,
    };
  },
};
</script>

<style>
.downloadable__container,
.downloadable__container-stickers {
  padding: 58px 0 40px;
  max-width: 1114px;
  margin: 0 auto;
  position: relative;
}

.downloadable__container-stickers {
  padding: 0 0 76px;
}

.downloadable__container h2 {
  margin-bottom: 40px;
  text-align: center;
}

.downloadable__swiper {
  max-width: 998px;
}

.downloadable__image,
.downloadable__sticker {
  border-radius: 16px;
  max-width: calc(100% - 30px);
  margin: 15px 15px 0 15px;
}
.downloadable__slide img,
.downloadable__sticker video{
  width: 100%;
  border-radius: 16px;
}

.downloadable__slide a {
  text-decoration: none;
  display: flex;
  max-width: 234px;
  margin: 53px auto 0;
}

@media only screen and (max-width: 768px) {
  .downloadable__container {
    padding: 26px 30px;
    max-width: 100%;
  }

  .downloadable__swiper {
    max-width: 300px;
  }
}

@media only screen and (max-width: 992px) {
  .downloadable__swiper {
    padding: 0 25px;
  }
}
</style>
